'use client';
import Image from 'next/image';
import React from 'react';

const MediaPartnersLogoSection = () => {
  const logos = [
  {
    src: '/images/realfi.webp',
    alt: 'PayRealFi',
    href: 'https://payrealfi.com/',
  },
  {
    src: '/images/wikibit.webp',
    alt: 'WikiBit',
    href: 'https://news.wikibit.com/',
  },
  {
    src: '/images/iciholder.webp',
    alt: 'ICOHolder',
    href: 'https://icoholder.com/',
  },
  {
    src: '/images/coinmeta.webp',
    alt: '528BTC',
    href: 'https://www.528btc.com/',
  },
  {
    src: '/images/gbc-logo.webp',
    alt: 'GBC Time',
    href: 'https://gbc-time.org/',
  },
  {
    src: '/images/birla-logo.webp',
    alt: 'Brila',
    href: 'https://brila.net/',
  },
  {
    src: '/images/btcwire.webp',
    alt: 'BTCWire',
    href: 'https://btcwire.io/',
  },
  {
    src: '/images/coinscapture.webp',
    alt: 'CoinsCapture',
    href: 'https://coinscapture.com/',
  },
  {
    src: '/images/edarabia-logo.webp',
    alt: 'Edarabia',
    href: 'https://www.edarabia.com/',
  },
  {
    src: '/images/bftimes.webp',
    alt: 'BFM Times',
    href: 'https://bfmtimes.com/',
  },
  {
    src: '/images/chaindecrypt.webp',
    alt: 'ChainDecrypt',
    href: 'https://chaindecrypt.com/',
  },
  {
    src: '/images/smartmoneymatch.webp',
    alt: 'Smart Money Match',
    href: 'https://www.smartmoneymatch.com/',
  },
  {
    src: '/images/transportstake.webp',
    alt: 'TransportStake',
    href: 'https://www.transportstake.com/',
  },
  {
    src: '/images/publicitymarketplace.webp',
    alt: 'Publicity Marketplace',
    href: 'https://www.publicitymarketplace.com/',
  },
  {
    src: '/images/functionalsourcing.webp',
    alt: 'Functional Sourcing',
    href: 'https://www.functionalsourcing.com/',
  },
  {
    src: '/images/educationstake.webp',
    alt: 'EducationStake',
    href: 'https://www.educationstake.com/',
  },
  {
    src: '/images/matchsdg.webp',
    alt: 'MatchSDG',
    href: 'https://www.matchsdg.com/',
  },
   {
    src: '/images/realbriefly.webp',
    alt: 'Real Briefly',
    href: 'https://www.realbriefly.com/',
  },
  {
    src: '/images/droomdroom-white-bg.webp',
    alt: 'DroomDroom',
    href: 'https://droomdroom.com/',
  },
  {
    src: '/images/blockchaintexno-black.webp',
    alt: 'Blockchain Texno',
    href: 'https://www.blockchaintexno.uz/',
  },
  {
    src: '/images/forkoff.webp',
    alt: 'ForkOff',
    href: 'https://forkoff.xyz/',
  },
  {
    src: '/images/blockchainmedia-id.webp',
    alt: 'Blockchain Media',
    href: 'https://blockchainmedia.id/',
  },
  {
    src: '/images/coingape.webp',
    alt: 'CoinGape',
    href: 'https://coingape.com/',
  },
  {
    src: '/images/securitymiddleeastmag.webp',
    alt: 'Security Middle East',
    href: 'https://www.securitymiddleeastmag.com/',
  },
  {
    src: '/images/tekafrika.webp',
    alt: 'Tek Afrika',
    href: 'https://tekafrika.tv/',
  },
  {
    src: '/images/nendigital.webp',
    alt: 'NEN Digital',
    href: 'http://www.nendigital.com/',
  },
  {
    src: '/images/cyberdefensemagazine.webp',
    alt: 'Cyber Defense Magazine',
    href: 'http://www.cyberdefensemagazine.com/',
  },
  {
    src: '/images/cio-review.webp',
    alt: 'CIOReview',
    href: 'https://www.cioreview.com/',
  },
  {
    src: "/images/zexprwire-logo.webp",
    alt: "zexprwire",
    link: "https://zexprwire.com/",
  },
];



  return (
    <div data-component-id="src/app/MediaPartnersLogoSection.jsx:157:4" data-component-path="src/app/MediaPartnersLogoSection.jsx" data-component-line="157" data-component-end-line="189" data-component-file="MediaPartnersLogoSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1240px%5D%20mx-auto%20flex%20flex-col%20items-center%20gap-%5B20px%5D%20sm%3Agap-%5B30px%5D%20md%3Agap-%5B40px%5D%20px-3%22%7D" className="max-w-[1240px] mx-auto flex flex-col items-center gap-[20px] sm:gap-[30px] md:gap-[40px] px-3">
      
      {/* Main Heading */}
      <h2 data-component-id="src/app/MediaPartnersLogoSection.jsx:160:6" data-component-path="src/app/MediaPartnersLogoSection.jsx" data-component-line="160" data-component-end-line="162" data-component-file="MediaPartnersLogoSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B18px%5D%20sm%3Atext-%5B27px%5D%20md%3Atext-%5B36px%5D%20font-poppins%20font-medium%20leading-%5B1.3%5D%20text-center%20bg-%5Blinear-gradient(1deg%2C%2317c64f_0%25%2C%2310b981_50%25%2C%23005529_100%25)%5D%20bg-clip-text%20text-transparent%22%2C%22textContent%22%3A%22Media%20Partners%22%7D" className="text-[18px] sm:text-[27px] md:text-[36px] font-poppins font-medium leading-[1.3] text-center bg-[linear-gradient(1deg,#17c64f_0%,#10b981_50%,#005529_100%)] bg-clip-text text-transparent">
        Media Partners
      </h2>

      {/* Logos Grid */}
      <div data-component-id="src/app/MediaPartnersLogoSection.jsx:165:6" data-component-path="src/app/MediaPartnersLogoSection.jsx" data-component-line="165" data-component-end-line="188" data-component-file="MediaPartnersLogoSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20lg%3Agrid-cols-5%20gap-4%20sm%3Agap-5%20md%3Agap-6%20w-full%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-5 md:gap-6 w-full">
        {logos.map((logo, idx) => (
          <a data-component-id="src/app/MediaPartnersLogoSection.jsx:167:10" data-component-path="src/app/MediaPartnersLogoSection.jsx" data-component-line="167" data-component-end-line="186" data-component-file="MediaPartnersLogoSection.jsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22block%20w-full%20h-%5B90px%5D%20bg-white%20sm%3Ah-%5B240px%5D%20md%3Ah-%5B90px%5D%20rounded-%5B10px%5D%20overflow-hidden%20flex%20items-center%20justify-center%20shadow-md%20p-4%22%7D"
            key={idx}
            href={logo.href}
            target="_blank"
           rel={
          logo.href === "https://www.cryptonewsz.com/"
            ? "noopener noreferrer"
            : "noopener noreferrer nofollow"
        }
            className="block w-full h-[90px] bg-white sm:h-[240px] md:h-[90px] rounded-[10px] overflow-hidden flex items-center justify-center shadow-md p-4"
          >
            <Image data-component-id="src/app/MediaPartnersLogoSection.jsx:178:12" data-component-path="src/app/MediaPartnersLogoSection.jsx" data-component-line="178" data-component-end-line="185" data-component-file="MediaPartnersLogoSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-%5B200px%5D%20h-%5B80px%5D%20object-contain%22%7D"
              src={logo.src}
              alt={logo.alt}
              width={200}
              height={200}
              unoptimized
              className="w-[200px] h-[80px] object-contain"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default MediaPartnersLogoSection;
